import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Asset } from '../../../common/generated-types';
import { ColorConfig, NavigationItem } from '../../../common/interfaces';
import { getNavigationItemHref } from '../../../common/utils/navigation-helpers';

interface NavigationColumn {
    name: string;
    items: NavigationItem[];
}

interface SnsInfo {
  facebook?: string;
  instagram?: string;
  xTwitter?: string;
  youtube?: string;
}

@Component({
  selector: 'vsf-page-footer',
  templateUrl: './page-footer.component.html',
  styleUrls: ['./page-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageFooterComponent implements OnInit, OnChanges {
  @Input() navigationColumns: NavigationColumn[];
  @Input() storeLogo: Asset;
  @Input() footerLogo: Asset;
  @Input() isMobile: boolean | null;
  @Input() snsInfo: SnsInfo;
  @Input() baseUrl: string;
  @Input() supportEmail: string;
  @Input() orderStatusHref: string;
  @Input() storeColor: ColorConfig;
  @Input() disclaimer: string = '';
  @Input() copyrightNotice: string = '';

  contactEmail: string = '';
  logo: Asset;

  constructor(private changeDetector: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.contactEmail = this.supportEmail ? this.supportEmail : 'support@dealomega.com';
    this.logo = this.footerLogo ?? this.storeLogo;
  }

  ngOnChanges(changes: SimpleChanges) {
    if('orderStatusHref' in changes && changes.orderStatusHref.currentValue !== this.orderStatusHref) {
      this.orderStatusHref = changes.orderStatusHref.currentValue;
      this.changeDetector.markForCheck();
    }
  }

  getItemHref(item: NavigationItem): string | null {
    return getNavigationItemHref(item, this.supportEmail);
  }

  isExternalNavItem(item: NavigationItem): boolean {
    if (item.targetType === 'website') return true;
    // 'contact-us' resolves to a mailto: href, not an internal route.
    if (item.targetType === 'built-in-site-page' && item.builtInPage === 'contact-us') return true;
    return false;
  }
}